const PermissionMatrix = ({
  permissions,
  selectedCodes,
  search,
  onSearchChange,
  onToggle,
  onSelectAll,
  onClearAll,
  onSubmit,
  submitting,
  roleName,
  editing,
  roleTypeLabel,
  disabled,
}) => {
  const grouped = permissions.reduce((acc, permission) => {
    const key = permission.moduleName || 'General';
    if (!acc[key]) acc[key] = [];
    acc[key].push(permission);
    return acc;
  }, {});

  return (
    <div className="min-w-0 overflow-hidden rounded-[28px] border border-[color:var(--admin-border)] bg-white shadow-sm">
      <div className="sticky top-[88px] z-10 grid gap-3 border-b border-[color:var(--admin-border)] bg-white px-5 py-4 lg:grid-cols-[minmax(0,1fr)_minmax(220px,280px)] lg:items-start">
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-[0.24em] text-[color:var(--admin-icon)]">Role name</div>
          <div className="mt-2 flex flex-wrap items-center gap-3">
            <div className="min-w-0 text-lg font-semibold text-[color:var(--admin-heading)]">{roleName || 'New custom role'}</div>
            {roleTypeLabel && (
              <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${roleTypeLabel === 'SYSTEM' ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'}`}>
                {roleTypeLabel}
              </span>
            )}
          </div>
        </div>
        <div className="grid gap-3">
          <input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search permissions"
            className="w-full rounded-full border border-[color:var(--admin-border)] px-4 py-2.5 text-sm outline-none focus:border-[var(--admin-accent)]"
          />
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onSelectAll}
              disabled={disabled}
              className="rounded-full border border-[color:var(--admin-border)] px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-[color:var(--admin-heading)] disabled:opacity-50"
            >
              Select all
            </button>
            <button
              type="button"
              onClick={onClearAll}
              disabled={disabled}
              className="rounded-full border border-[color:var(--admin-border)] px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-[color:var(--admin-heading)] disabled:opacity-50"
            >
              Clear all
            </button>
            <button
              type="button"
              onClick={onSubmit}
              disabled={disabled || submitting}
              className="rounded-full bg-[var(--admin-accent)] px-5 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-white disabled:opacity-60"
            >
              {submitting ? 'Saving...' : editing ? 'Update role' : 'Create role'}
            </button>
          </div>
        </div>
      </div>

      <div className="p-5">
        {Object.entries(grouped).map(([moduleName, items]) => (
          <section key={moduleName} className="mb-6 last:mb-0">
            <h3 className="text-xs font-semibold uppercase tracking-[0.24em] text-[color:var(--admin-icon)]">{moduleName}</h3>
            <div
              className="mt-3 grid gap-3"
              style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))' }}
            >
              {items.map((permission) => {
                const checked = selectedCodes.includes(permission.permissionCode);
                return (
                  <label
                    key={permission.id || permission.permissionCode}
                    className={`min-w-0 rounded-2xl border px-4 py-4 shadow-sm ${
                      checked ? 'border-[var(--admin-accent)] bg-[rgba(15,92,90,0.06)]' : 'border-[color:var(--admin-border)] bg-[var(--admin-muted-surface)]'
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <input
                        type="checkbox"
                        checked={checked}
                        disabled={disabled}
                        onChange={() => onToggle(permission.permissionCode)}
                        className="mt-1 shrink-0"
                      />
                      <div className="min-w-0 break-words">
                        <div className="text-sm font-semibold leading-5 text-[color:var(--admin-heading)]">{permission.permissionName}</div>
                        <div className="mt-1 text-sm leading-6 text-[color:var(--admin-text)]">{permission.description}</div>
                        <div className="mt-3 text-[10px] uppercase tracking-[0.22em] text-[color:var(--admin-icon)]">
                          {permission.permissionCode}
                        </div>
                      </div>
                    </div>
                  </label>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default PermissionMatrix;
